import React, { Component } from 'react'
import ls from 'local-storage'
import GatsbyLink from '../GatsbyLink'
import './Quote.scss'
import { navigate } from 'gatsby'

export default class AddToQuote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      quote: ls.get('quote') ? ls.get('quote') : [],
      loaded: false,
      error: null,
      hasSubmitted: false,
      showNotes: false,
      product: {
        productId: this.props.productId,
        options: {},
        note: '',
        qty: 1,
      },
    }
  }

  componentDidMount() {
    if (this.props.options.colours.length === 1) {
      this.setOption('colour', this.props.options.colours[0])
    }
  }

  handleSubmit = e => {
    const { settings = [], redirect = false } = this.props
    const { quotePage = '/quote-cart/' } = settings
    e.preventDefault()
    this.setState({ loading: true })

    if (
      this.props.options.colours.length > 0 &&
      !this.state.product.options.colour
    ) {
      return this.setState({ error: true })
    }

    const productArray = this.state.product
    const newArray = this.state.quote.concat(productArray)
    ls.set('quote', newArray)
    this.setState({
      loading: false,
      submitted: true,
      quote: newArray,
      hasSubmitted: true,
    })
    if (redirect) {
      navigate(quotePage)
    }
  }

  setOption = (option, value) => {
    const { updateActiveImage } = this.props
    let product = this.state.product
    product.options[option] = value
    this.setState({ product })
    updateActiveImage(value.colourImage)
  }

  toggleNote = e => {
    e.preventDefault()
    this.setState({ showNotes: this.state.showNotes ? false : true })
  }

  //Form change
  handleChange(e) {
    let product = this.state.product
    product[e.target.name] = e.target.value
    this.setState({ product })
  }

  render() {
    if (!this.props) return null
    const { settings = [], options } = this.props
    //console.log('options:',options)
    const { hasSubmitted, product, showNotes, error } = this.state
    const {
      showPrice = false,
      showQuantity = false,
      pricePrefix = null,
      priceSuffix = null,
      priceDescription = '',
      quotePage = '/quote-cart/',
      showProductNote = false,
    } = settings
    return (
      <div className="product-quote-action">
        {hasSubmitted && (
          <div className="message">
            <p>This product has been added to the quote.</p>
            <GatsbyLink className="view-quote" to={quotePage}>
              View quote
            </GatsbyLink>
          </div>
        )}
        {options && options.colours && !hasSubmitted && (
          <div className="options">
            <div className="option">
              {options.colours && options.colours.length > 0 && (
                <>
                  <div className="label">
                    <p>Available colours</p>
                  </div>
                  <div className="colours">
                    {options.colours.map((colour, index) => (
                      <div
                        key={index}
                        className={`colour${
                          product.options.colour &&
                          product.options.colour.colourName ===
                            colour.colourName
                            ? ' active'
                            : ''
                        }`}
                        style={{
                          backgroundColor: colour.colourHex
                            ? colour.colourHex
                            : null,
                        }}
                        onClick={event => this.setOption('colour', colour)}
                      >
                        <span className="colour-name">{colour.colourName}</span>
                      </div>
                    ))}
                    {!product.options.colour && error && (
                      <div className="required-message">
                        Please select a colour
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        {!hasSubmitted && (
          <form
            onSubmit={event => {
              this.handleSubmit(event)
            }}
            className="form"
          >
            <div className="form-inner">
              {showProductNote && (
                <>
                  <button
                    className="toggle-note-box"
                    onClick={event => this.toggleNote(event)}
                    aria-label="Quote note"
                  >
                    {showNotes ? 'Hide quote note' : 'Add a quote note'}
                  </button>
                  <div
                    className={`note-box ${showNotes ? 'show' : 'hide'}${
                      product.note ? ' active' : ''
                    }`}
                  >
                    <label htmlFor="note">Add a note</label>
                    <textarea
                      name="note"
                      id="note"
                      placeholder="Add a note"
                      onChange={e => this.handleChange(e)}
                      value={product.note}
                    />
                  </div>
                </>
              )}
              {options.variations && options.variations.length > 0 && (
                <div className={`variations${product.qty ? ' active' : ''}`}>
                  <label htmlFor="variation">Size</label>
                  <select
                    name="variation"
                    id="variation"
                    onChange={e => this.handleChange(e)}
                    required
                  >
                    <option value="">Please select</option>
                    {options.variations.map((variation, index) => (
                      <option value={variation.variationName} key={index}>
                        {variation.variationName}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className={`row${product.qty ? ' active' : ''}`}>
                <div className={`quantity${product.qty ? ' active' : ''}`}>
                  <div className="qty-input">
                    <label htmlFor="qty">Qty</label>

                    {/* QTY */}
                    <input
                      type="number"
                      name="qty"
                      id="qty"
                      placeholder="Qty"
                      onChange={e => this.handleChange(e)}
                      value={product.qty}
                    />
                  </div>
                  <div className="add-minus__container">
                    <button
                      className="add-minus-button"
                      onClick={e => {
                        e.preventDefault()
                        this.setState({
                          product: { ...product, qty: product.qty + 1 },
                        })
                      }}
                    >
                      +
                    </button>
                    <button
                      className="add-minus-button"
                      disabled={this.state.product.qty === 1 ? true : false}
                      onClick={e => {
                        e.preventDefault()
                        this.setState({
                          product: {
                            ...product,
                            qty: product.qty > 1 ? product.qty - 1 : 1,
                          },
                        })
                      }}
                    >
                      -
                    </button>
                  </div>
                </div>

                <div className="add-to-quote-button">
                  <button
                    className="add-to-quote"
                    type="submit"
                    aria-label="Add to quote"
                  >
                    Add to quote
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </div>
    )
  }
}
